export default __webpack_public_path__ + "static/media/checkCircle.930043a4.svg";